module.exports = __webpack_public_path__ + "static/media/contentInsurance.0854c166.png";